const CONTACT_EMAIL_OBFUSCATED = 'оfficе@оllаа.аpp';
const REPRESENTED_BY_OBFUSCATED = 'Wаldеmаr Косh';
const REPRESENTED_BY_LINE = `vertreten durch ${REPRESENTED_BY_OBFUSCATED}`;

const datenschutz = {
  title: 'Datenschutz',
  subtitle: 'Datenschutzerklärung',
  date: '18.06.2026',
  sections: [
    {
      heading: '1. Verantwortlicher',
      paragraphs: [
        'Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO):',
        'Ollaa.app',
        'Goethestraße 37',
        '60313 Frankfurt am Main',
        'Deutschland',
        `E-Mail: ${CONTACT_EMAIL_OBFUSCATED}`,
        REPRESENTED_BY_LINE,
      ],
    },
    {
      heading: '2. Allgemeines zur Datenverarbeitung',
      paragraphs: [
        'Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der geltenden Datenschutzgesetze, insbesondere der DSGVO und des Bundesdatenschutzgesetzes (BDSG).',
      ],
    },
    {
      heading: '3. Welche Daten wir verarbeiten',
      paragraphs: [
        'Bei Nutzung unserer Website und Web-App können folgende Daten verarbeitet werden:',
        '• Vor- und Nachname',
        '• E-Mail-Adresse',
        '• Telefonnummer',
        '• Login-Daten',
        '• Mitgliedschaftsstatus',
        '• Zahlungsinformationen',
        '• Nutzungsdaten',
        '• Geräte- und Browserinformationen',
        '• IP-Adresse',
        '• Standortdaten (nur nach Freigabe durch den Nutzer)',
      ],
    },
    {
      heading: '4. Zwecke der Verarbeitung',
      paragraphs: [
        'Wir verarbeiten personenbezogene Daten insbesondere zur:',
        '• Bereitstellung der Plattform',
        '• Verwaltung von Nutzerkonten',
        '• Abwicklung von Mitgliedschaften',
        '• Bereitstellung von Deals, Events und Touren',
        '• Kommunikation mit Nutzern',
        '• Missbrauchs- und Betrugsprävention',
        '• Analyse und Verbesserung unserer Dienste',
      ],
    },
    {
      heading: '5. Rechtsgrundlagen',
      paragraphs: [
        'Die Verarbeitung erfolgt auf Grundlage von:',
        '• Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)',
        '• Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)',
        '• Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)',
      ],
    },
    {
      heading: '6. Hosting',
      paragraphs: [
        'Unsere Plattform wird bei folgendem Anbieter gehostet:',
        'Hetzner Online GmbH',
        'Industriestraße 25',
        '91710 Gunzenhausen',
        'Deutschland',
        'Die Verarbeitung erfolgt auf Grundlage eines Auftragsverarbeitungsvertrages gemäß Art. 28 DSGVO.',
      ],
    },
    {
      heading: '7. Zahlungsdienstleister',
      paragraphs: [
        'PayPal',
        'Für Zahlungen nutzen wir PayPal. Dabei werden die für die Zahlungsabwicklung erforderlichen Daten an PayPal übermittelt.',
        'Stripe',
        'Für Kreditkarten- und weitere Onlinezahlungen nutzen wir Stripe. Dabei werden die für die Zahlungsabwicklung erforderlichen Daten an Stripe übermittelt.',
        'Es gelten zusätzlich die Datenschutzbestimmungen der jeweiligen Anbieter.',
      ],
    },
    {
      heading: '8. Analyse-Tools',
      paragraphs: [
        'Die Ollaa Partner-App setzt keine Analyse- oder Tracking-Tools ein.',
        'Es werden ausschließlich technisch notwendige Speicher für den Betrieb der App verwendet.',
      ],
    },
    {
      heading: '9. Partnerbetriebe',
      paragraphs: [
        'Zur Einlösung von Deals und Vorteilen kann es erforderlich sein, dass bestimmte Informationen über die Mitgliedschaft an teilnehmende Partnerbetriebe übermittelt werden.',
        'Hierzu zählen beispielsweise:',
        '• Mitgliedschaftsstatus',
        '• Dealberechtigung',
        '• Einlösungsstatus',
        'Es werden nur die jeweils erforderlichen Daten übermittelt.',
      ],
    },
    {
      heading: '10. Cookies',
      paragraphs: [
        'Wir verwenden ausschließlich technisch notwendige Cookies und lokale Speicher.',
        'Es werden keine Analyse- oder Marketing-Cookies eingesetzt.',
      ],
    },
    {
      heading: '11. Speicherdauer',
      paragraphs: [
        'Personenbezogene Daten werden nur solange gespeichert, wie dies zur Vertragserfüllung oder aufgrund gesetzlicher Aufbewahrungspflichten erforderlich ist.',
      ],
    },
    {
      heading: '12. Rechte der Betroffenen',
      paragraphs: [
        'Nutzer haben folgende Rechte:',
        '• Auskunft',
        '• Berichtigung',
        '• Löschung',
        '• Einschränkung der Verarbeitung',
        '• Datenübertragbarkeit',
        '• Widerspruch gegen die Verarbeitung',
        '• Widerruf erteilter Einwilligungen',
        `Anfragen können an ${CONTACT_EMAIL_OBFUSCATED} gerichtet werden.`,
      ],
    },
    {
      heading: '13. Beschwerderecht',
      paragraphs: [
        'Nutzer haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.',
      ],
    },
    {
      heading: '14. Datensicherheit',
      paragraphs: [
        'Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um personenbezogene Daten vor Verlust, Missbrauch oder unbefugtem Zugriff zu schützen.',
      ],
    },
    {
      heading: '15. Änderungen der Datenschutzerklärung',
      paragraphs: [
        'Wir behalten uns vor, diese Datenschutzerklärung anzupassen, sofern dies aufgrund rechtlicher, technischer oder geschäftlicher Änderungen erforderlich wird.',
      ],
    },
  ],
};

const impressum = {
  title: 'Impressum',
  subtitle: 'Angaben gemäß § 5 TMG',
  date: '19.06.2026',
  sections: [
    {
      heading: 'Anbieter',
      paragraphs: [
        'Ollaa | Exklusive Deals & Erlebnisse – Nur für Mitglieder',
        'Goethestraße 37',
        '60313 Frankfurt am Main',
        'Deutschland',
        'Einzelunternehmen',
      ],
    },
    {
      heading: 'Kontakt',
      paragraphs: [`E-Mail: ${CONTACT_EMAIL_OBFUSCATED}`],
    },
    {
      heading: 'Vertreten durch',
      paragraphs: [REPRESENTED_BY_OBFUSCATED],
    },
    {
      heading: 'Gewerbeanmeldung',
      paragraphs: ['Die Gewerbeanmeldung erfolgte bei der Stadt Frankfurt am Main.'],
    },
    {
      heading: 'Umsatzsteuer-ID',
      paragraphs: ['Nicht umsatzsteuerpflichtig gemäß § 19 UStG (Kleinunternehmerregelung).'],
    },
    {
      heading: 'Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV',
      paragraphs: [
        'Ollaa | Exklusive Deals & Erlebnisse – Nur für Mitglieder',
        'Goethestraße 37',
        '60313 Frankfurt am Main',
        REPRESENTED_BY_LINE,
      ],
    },
    {
      heading: 'EU-Streitschlichtung',
      paragraphs: [
        'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:',
        'https://ec.europa.eu/consumers/odr/',
        'Unsere E-Mail-Adresse finden Sie oben im Impressum.',
      ],
    },
    {
      heading: 'Verbraucherstreitbeilegung',
      paragraphs: [
        'Wir nehmen nicht an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil.',
      ],
    },
    {
      heading: 'Haftungsausschluss',
      paragraphs: [
        'Trotz sorgfältiger inhaltlicher Kontrolle wird keine Haftung für die Inhalte externer Links übernommen. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.',
      ],
    },
    {
      heading: 'Urheberrecht',
      paragraphs: [
        `Alle Inhalte, Bilder und Texte dieser Website sind urheberrechtlich geschützt. Die Vervielfältigung oder Verwendung bedarf der ausdrücklichen schriftlichen Zustimmung von Ollaa ${REPRESENTED_BY_LINE}`,
      ],
    },
  ],
};

export const legalDocuments = {
  agb: {
    title: 'AGB',
    subtitle: 'Partner-AGB für Ollaa.app',
    date: '18.06.2026',
    sections: [
      {
        heading: '1. Vertragsparteien',
        paragraphs: [
          'Diese Partner-AGB regeln die Zusammenarbeit zwischen',
          'Ollaa.app',
          'Goethestraße 37',
          '60313 Frankfurt am Main',
          'Deutschland',
          REPRESENTED_BY_LINE,
          '(nachfolgend „Ollaa")',
          'und dem jeweiligen Partnerbetrieb (nachfolgend „Partner").',
        ],
      },
      {
        heading: '2. Leistungsgegenstand',
        paragraphs: [
          'Ollaa betreibt eine digitale Plattform für exklusive Deals, Events und Erlebnisse.',
          'Der Partner stellt seinen Betrieb, ausgewählte Angebote oder Veranstaltungen auf der Plattform vor und gewährt Mitgliedern die vereinbarten Vorteile.',
        ],
      },
      {
        heading: '3. Partner-Angebote',
        paragraphs: [
          'Der Partner kann unter anderem folgende Angebote bereitstellen:',
          '• Rabatte',
          '• 2-für-1-Angebote',
          '• Gratis-Produkte',
          '• Freigetränke',
          '• Freispeisen',
          '• vergünstigte Eintritte',
          '• kostenfreie Eintritte',
          '• Sonderaktionen',
          '• Veranstaltungen',
          '• geführte oder selbstgeführte Touren',
          'Die konkreten Bedingungen werden vom Partner festgelegt und auf der Plattform veröffentlicht.',
        ],
      },
      {
        heading: '4. Mindestanforderungen an Angebote',
        paragraphs: [
          'Der Partner verpflichtet sich, während der Zusammenarbeit mindestens zwei aktive Angebote bereitzustellen:',
          '• mindestens ein Angebot mit einem Kundenvorteil von bis zu 5 € oder vergleichbarem Gegenwert',
          '• mindestens ein Angebot mit einem Kundenvorteil von mindestens 10 € oder vergleichbarem Gegenwert',
          'Alternativ können gleichwertige Mehrwertangebote wie 2-für-1-Aktionen, Gratis-Produkte oder kostenfreie Eintritte bereitgestellt werden.',
        ],
      },
      {
        heading: '5. Kontingente und Verfügbarkeit',
        paragraphs: [
          'Der Partner kann für seine Angebote:',
          '• Zeiträume',
          '• Wochentage',
          '• Uhrzeiten',
          '• Teilnehmerzahlen',
          '• Kontingente',
          '• Reservierungspflichten',
          'festlegen.',
          'Der Partner ist dafür verantwortlich, dass veröffentlichte Angebote tatsächlich verfügbar sind.',
        ],
      },
      {
        heading: '6. Einlösung',
        paragraphs: [
          'Der Partner akzeptiert gültige Einlösungen über die Ollaa-Plattform gemäß den veröffentlichten Bedingungen.',
          'Missbrauchsverdacht oder technische Probleme sind Ollaa unverzüglich mitzuteilen.',
        ],
      },
      {
        heading: '7. Inhalte und Darstellung',
        paragraphs: [
          'Der Partner versichert, dass alle bereitgestellten Informationen korrekt, aktuell und rechtlich zulässig sind.',
          'Der Partner räumt Ollaa das Recht ein, bereitgestellte Texte, Bilder, Logos und Beschreibungen zur Bewerbung des Angebots auf Website, App und Social-Media-Kanälen zu verwenden.',
          'Der Partner bleibt Inhaber seiner Marken- und Urheberrechte.',
        ],
      },
      {
        heading: '8. Partnerprofil',
        paragraphs: [
          'Der Partner ist für die Aktualität seiner Angaben verantwortlich, insbesondere:',
          '• Öffnungszeiten',
          '• Kontaktdaten',
          '• Angebotstexte',
          '• Reservierungshinweise',
          '• Verfügbarkeiten',
        ],
      },
      {
        heading: '9. Vergütung',
        paragraphs: [
          'Die Vergütung richtet sich nach dem individuell vereinbarten Partnerpaket oder Kooperationsvertrag.',
          'Sofern nichts anderes vereinbart wurde, erfolgt keine automatische Erfolgs- oder Umsatzbeteiligung.',
        ],
      },
      {
        heading: '10. Haftung',
        paragraphs: [
          'Der Partner ist allein verantwortlich für die Durchführung seiner Leistungen gegenüber den Nutzern.',
          'Ollaa übernimmt keine Haftung für:',
          '• Umsatzerwartungen',
          '• Besucherzahlen',
          '• Buchungszahlen',
          '• wirtschaftliche Erfolge',
          'Ollaa haftet nur bei Vorsatz, grober Fahrlässigkeit sowie in gesetzlich zwingenden Fällen.',
        ],
      },
      {
        heading: '11. Laufzeit und Kündigung',
        paragraphs: [
          'Die Zusammenarbeit kann von beiden Parteien jederzeit mit einer Frist von 30 Tagen zum Monatsende schriftlich oder in Textform gekündigt werden, sofern keine individuelle Vereinbarung etwas anderes regelt.',
          'Das Recht zur außerordentlichen Kündigung bleibt unberührt.',
        ],
      },
      {
        heading: '12. Sperrung und Entfernung von Angeboten',
        paragraphs: [
          'Ollaa kann Angebote oder Partnerprofile vorübergehend deaktivieren oder entfernen, wenn:',
          '• gesetzliche Verstöße vorliegen,',
          '• Nutzer gefährdet werden,',
          '• irreführende Angaben gemacht werden,',
          '• wiederholt Beschwerden über die Einlösung eingehen.',
        ],
      },
      {
        heading: '13. Datenschutz',
        paragraphs: [
          'Beide Parteien verpflichten sich zur Einhaltung der geltenden Datenschutzgesetze.',
          'Personenbezogene Daten dürfen ausschließlich zur Durchführung der jeweiligen Angebote verwendet werden.',
        ],
      },
      {
        heading: '14. Schlussbestimmungen',
        paragraphs: [
          'Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.',
          'Sollte eine Bestimmung dieser Vereinbarung unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.',
          'Gerichtsstand, soweit gesetzlich zulässig, ist Frankfurt am Main.',
        ],
      },
    ],
  },
  datenschutz,
  impressum,
};
